<template>
<div class="customerWrapper">
	<!-- <div class="customer_header">
	        <span v-show="targetUserName" >{{$t('other.a1087')}}：{{$t('other.a1088')}}{{targetIndex+1}} {{$t('other.a363')}}</span>
	        <span v-show="!targetUserName" >暂无会话内容</span>
	        
	</div> -->
    <div class="customerBox">
	  <el-scrollbar wrap-style="overflow-x:hidden;">
		  <div class="customer_left">
		      <div class="user_num">{{$t('other.a364')}}<el-button type="primary" size="mini" style="margin-left:5px" @click="refresh">{{$t('other.a3204')}}</el-button></div>
		      <div>
		          <div :class="{'shop_message':true,'active':targetIndex == index} "  v-for="(item,index) in userList" :key="index" @click="targetUser(item,index)"   @contextmenu.prevent="talkItemsMenu(item, $event)">
					  <div v-show="targetIndex == index" class="mess_con" @click="delttemess"><i class="el-icon-close"></i>
					  
					  </div>
            <div v-show="item.unreadCount!=0" class="mess_cons">
              <el-badge :value="item.unreadCount" :max="99" class="item">       
                      </el-badge>
            </div>
		              <div class="head_img_box">
		                  <img src="../../../assets/img/boy.png"/>
		              </div>
		              <div>
		                  <div class="mess_body">
		  					     <span class="user_name" v-show="item.conversationType=='buyer'">{{item.latestMessageContent}}</span>
                     <span class="user_name" v-show="item.conversationType=='supplier'">{{item.answerUserId}}</span>
								 <span v-show="item.conversationType=='supplier'">{{$t('other.a3205')}}</span>
								 <span v-show="item.conversationType=='buyer'">{{$t('other.a849')}}</span>
		  						 <!-- <span v-show="item.unreadCount" style="font-size: 12px; color: red;">{{item.unreadCount}}个新消息</span> -->
                    <!-- <span v-show="item.unreadCount">
                      <el-badge :value="item.unreadCount" :max="99" class="item">       
                      </el-badge>
                    </span> -->
								 
		  					</div>
		                  <div class="user_name messge_buyer ">{{item.latestMessageTimestamp==null?$t('other.a354') : getCurrnetTime(item.latestMessageTimestamp)}}</div>
		              </div>
		          </div>
		      </div>
		  
		  </div>
	  </el-scrollbar>
      
      <div class="customer_right">
         <div id="dialogue_box" class="customer_chat_recode">
             <ul>
                 <li :class="{'chat_recode_items':true,'reverse_row':item.fromUserId == userId}" v-for="(item,index) in chatingList" :key="index">
                     <div class="pic_box">
						<img src="../../../assets/img/boy.png"/>
					</div>
					<div  v-if="item.messageType=='image'" :class="{'chat_desc_pic':item.fromUserId != userId,'reverse_desc_row_pic':item.fromUserId == userId}" @click="knowmessage(item)">
							 <el-image
									style="width: 100px; height: 100px"
									:src="item.content"
									:preview-src-list="srcList"
									fit="fit"></el-image>
					</div>
                     <div v-else :class="{'chat_desc':item.fromUserId != userId,'reverse_desc_row':item.fromUserId == userId}" >{{item.content}}</div>
                     <div v-show="item.fromUserId == userId" class="isRead">{{item.isRead ? $t('other.a365') : $t('other.a367')}}</div>
                 </li>
             </ul>
         </div>
         <div class="middle_content">
            <el-upload
                    class="upload-demo left"
                    ref="upload"
                    action="/"
                    :http-request="uploadFile_"
                    :auto-upload="true"
                    :show-file-list="false"
                    
                  >
                  <i
                      class="iconfont icon-xiangce"
                      style="font-size: 20px"
                    />
                  </el-upload>
			 <el-popover
                    placement="top"
                    
                    width="300"
                    trigger="click"
                   >
                   <div >
                      <img :src="face.url" alt="" v-for="(face,index) in sticker" :key="index" style="width:60px;height:60px;cursor: pointer;" @click="sendface(face)">
                   </div>
                   <i
                      class="iconfont icon-biaoqing  left"
                      style="font-size: 20px;margin-left:20px;cursor: pointer;"
                      slot="reference"
                      
                    />
                  </el-popover>

         </div>
         <div class="textBox_wrapper">
            <textarea class="textBox" v-model="textDesc" contenteditable="true"></textarea>
            <el-button class="sendBtn" type="primary" @click="sendMessage()">{{$t('other.a369')}}</el-button>
         </div>

      </div>
	  <el-dialog :title="$t('chat.hint')" :visible.sync="dialogVisible" width="30%">
      <el-row class="center">
        <ul>
          <li>
            <el-image :src="sendImgUrl" fit="contain"></el-image>
          </li>
        </ul>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sendImg(false)">{{$t('chat.cancel')}}</el-button>
        <el-button type="primary" @click="sendImg(true)">{{$t('chat.confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</div>

  
</template>

<script>
import api from "../../../api/moudles/chat";
import axios from "axios";
// import api from '../../api/api.js'
export default {
data(){
return{
	srcList: [
         
        ],
    dialogVisible:false,
    messagelist:[],
	userList:[],
    textDesc:'',
	targetIndex:-1,
	userId:JSON.parse(localStorage.getItem('userInfo')).userId,
	targetUserName:'',
	timeOut:1000,
	params:{
		userId:JSON.parse(localStorage.getItem('adminInfo')) ? JSON.parse(localStorage.getItem('adminInfo')).userId : '',
		lastTime:0
    },
    chatingList:[],//消息数组
    sendImgUrl:null,
	sticker:[
        {
          sticker_id:"004",
          sticker_package_id:"shogi2",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi2/004@1x.png"
        },
        {
          sticker_id:"0003",
          sticker_package_id:"shogi4",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi4/0003@1x.png"
        },
        {
          sticker_id:"0008",
          sticker_package_id:"shogi_th",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi_th/0008@1x.png"
        },
        {
          sticker_id:"0003",
          sticker_package_id:"shogi_th",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi_th/0003@1x.png"
        },
        {
          sticker_id:"0001",
          sticker_package_id:"shogi_th",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi_th/0001@1x.png"
        },
        {
          sticker_id:"0004",
          sticker_package_id:"shogi3",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi3/0004@1x.png"
        },
        {
          sticker_id:"016",
          sticker_package_id:"shogi2",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi2/016@1x.png"
        },
        {
          sticker_id:"0004",
          sticker_package_id:"shogi4",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi4/0004@1x.png"
        },
        {
          sticker_id:"0002",
          sticker_package_id:"shogi3",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi3/0002@1x.png"
        },
        {
          sticker_id:"002",
          sticker_package_id:"shogi2",
          url:"https://cdn.shopee.co.th/shopee/shopee-sticker-live-th/packs/shogi2/002@1x.png"
        }
      ],


}
},

computed:{
  // ...mapState({
  //     userId: (state) => state.shopaccess.userInfo.userId,
  //   }),
//  chatingList(){
// 	 let list=[]
// 	 list=this.messagelist.map(p => {
// 		 if(p.comeFrom == this.userId){
// 			 p.type="seller"
// 		 }else{
// 			 p.type='buyer'
// 		 }
// 		 return p
// 	 })
// 	 console.log('list',list)
// 	 return list
//  },

   
},

watch:{
  

},

created(){
   this.init()
   this.connectWebsocket();
},
mounted(){
   
//绑定事件
window.addEventListener('keydown',this.keyDown);
},
destroyed(){
        window.removeEventListener('keydown',this.keyDown,false);
},
methods:{
	knowmessage(e){
		console.log(e);
		
		// this.srcList.push(e.content);
	},
	refresh(){
		this.getUserMessage();//{{$T('OTHER.A3204')}}
		this.$message({
          message: this.$t('other.a1228'),
          type: 'success'
        });
	},
	    //会话列表右键菜单
    talkItemsMenu(item, event) {
		console.log(item);
	  let items = {
        items: [
          {
            label: 'sdasd',
            onClick: () => {
              window.open(
                "https://erp.shopsbu.com/cus/cancel/authorize/url/get",
                "_blank"
              );
            },
          },
        ],
        event: event,
        zIndex: 10000,
	  };
	  
      this.$contextmenu(items);
      return false;
    },
    getCurrnetTime(dateData){
	  var date = new Date(dateData)
	      var y = date.getFullYear()
	      var m = date.getMonth() + 1
	      m = m < 10 ? ('0' + m) : m
	      var d = date.getDate()
	      d = d < 10 ? ('0' + d) : d
		  var h = date.getHours()
		  h = h < 10 ? ('0' + h) : h
		  var i = date.getMinutes()
		  i = i < 10 ? ('0' + i) : i
		  var s = date.getSeconds()
		  s = s < 10 ? ('0' + s) : s
	      const time = y + '-' + m + '-' + d + ' ' + h+ ':' + i +":" +s
	      return time.slice(5,19);

	},
     // 获取当前年月
    getToday() {
      function completeDate(value) {
        return value < 10 ? "0" + value : value;
      }
      var char = "-";
      var nowDate = new Date();
      var day = nowDate.getDate();
      var month = nowDate.getMonth() + 1; //注意月份需要+1
      var year = nowDate.getFullYear();
      //补全0，并拼接
      return year + char + completeDate(month) + char + completeDate(day);
    },
	//当天的消息返回具体时间，非当天的消息返回年月日
    getConversationsTime(time) {
      var date = this.getToday();
      if (time.slice(0, 10) == date) {
        return time.slice(11, 19);
      } else {
        return time.slice(0, 10);
      }
    },
	handlePreview(file) {
	console.log(file);
	this.textDesc=file.data
	},
	
	getFilePath(){
	    const inputFile = this.$refs.filElem
		console.log(inputFile)
		inputFile.addEventListener('onclick')
	          
	},
	//跳转聊天底部
    talkPanelScrollBottom() {
      let el = document.getElementById("dialogue_box");
      el.scrollTop = el.scrollHeight;
    },
    oop(){
        this.$nextTick(function(){
            this.div = document.getElementById('dialogue_box');
            this.div.scrollTop = this.div.scrollHeight;
            console.log(this.div)
             console.log('555',this.div.scrollHeight)
             console.log('444',this.div.scrollTop)
            
        })

	},
	sendface(e){
		console.log(e);
		api
          .messageinsert({
             answerUserId   : this.targetUserName,
             conversationId : this.targetUserId,
             createUserId  : this.targetUserName,
             fromUserId : this.userId,
             messageContent : e.url,
             messageType : 'image',
             toUserId : this.targetUserName
          })
          .then((res) => {
            console.log(res);
            if(res.code == 'ok'){
                // this.dialogVisible = false;
				
				this.getmessagecon(this.targetUserId);
				
            }
            // this.$set(this.answerRecommend, index, res.translation);
            // e = res.translation;
            // console.log(e);
          });
	},//发送表情
	 //发送图片
    sendImg(e) {
      if (e) {
       api
          .messageinsert({
             answerUserId   : this.targetUserName,
             conversationId : this.targetUserId,
             createUserId  : this.targetUserName,
             fromUserId : this.userId,
             messageContent : this.sendImgUrl,
             messageType : 'image',
             toUserId : this.targetUserName
          })
          .then((res) => {
            console.log(res);
            if(res.code == 'ok'){
                this.dialogVisible = false;
				
				this.getmessagecon(this.targetUserId);
				
            }
            // this.$set(this.answerRecommend, index, res.translation);
            // e = res.translation;
            // console.log(e);
          });
      } else {
        // this.$message.error(this.$t("chat.Cancelledsend"));
        this.dialogVisible = false;
      }
    },
	uploadFile_(e) {
			console.log(e)
			  this.uploadFile(e.file);
			 
	},
	 uploadFile(file) {
      let formdata = new FormData();
      formdata.append("photo", file);
      formdata.append("fileName", file.name);
	  const h = this.$createElement;
	  console.log(formdata);
      axios
        .post("https://erp.shopsbu.com/cus/notice/image/upload", formdata, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
			console.log(res.data);
			console.log(res.data.photoUrl);
			// this.dialogImageUrl = res.data.photoUrl;
          if (res.data.code == "ok") {
            this.dialogVisible = true;
			this.sendImgUrl = res.data.photoUrl;
			console.log(this.sendImgUrl);
          } else {
            this.$message.error(this.$t('other.a3200'));
          }
        });
    },

    init(){
		// if(JSON.parse(localStorage.getItem('adminInfo'))){
		// 	this.userId=JSON.parse(localStorage.getItem('adminInfo')).userId
		// }
		console.log(this.userId)
		this.getUserMessage()
    },
	delttemess(){
		this.$confirm(this.$t('other.a3201'), this.$t("other.a142"), {
			  confirmButtonText: this.$t('other.a145'),
			  cancelButtonText: this.$t('other.a146'),
			  type: 'warning'
			}).then(() => {
			  api
				.deleteconver({
					conversationId  : this.targetUserId 
				})
				.then((res) => {
					console.log(res);
					if(res.code == 'ok'){
						
						this.$message.success(this.$t('other.a3202'))
						this.getUserMessage();
					}else{
						
					}
					
					
				});
			})
		
	},//删除会话
    //点击会话列表时触发
    targetUser(item,index){
        console.log(item)
		
        this.targetIndex=index
		// this.messagelist=item.messages
        this.targetUserName=item.createUserId

        this.targetUserId=item.conversationId;
        console.log(this.targetUserId);
		this.getmessagecon(this.targetUserId);
		this.readmessage(this.targetUserId);//将会话已读
		
        // // this.messageTo=item.userAccount
		
		
        
        

        
    },
    getmessagecon(conversationId){
        api
          .getmessage({
            conversationId : conversationId
          })
          .then((res) => {
            console.log(res);
            if(res.code == 'ok'){
                let arr = res.messages;

			this.chatingList = arr.reverse();
			this.readMessage();//将消息已读
			this.oop();//固定到底部
            console.log(this.chatingList);
            }else{
                
            }
            
            
          });
      },

    keyDown(e){
		if(e.keyCode === 13) {
			this.sendMessage()
			
		}
	},
	//标记会话为已读
	readmessage(conversationId){
		api
          .markread({
            
             conversationId : conversationId,
             isRead : '1'
          })
          .then((res) => {
            console.log(res);
            if(res.code == 'ok'){
				this.getUserMessage();//重新获取会话列表状态
			}
          });
	},
    sendMessage(){
		if(!this.targetUserName){
			this.$message.warning(this.$t('other.a3203'))
			return
		}
        if(!this.textDesc){
            this.$message.warning(this.$t('other.a370'))
            return
        }
        api
          .messageinsert({
             answerUserId   : this.userId,
             conversationId : this.targetUserId,
             createUserId  : this.targetUserName,
             fromUserId : this.userId,
             messageContent : this.textDesc,
             messageType : 'text',
             toUserId : this.targetUserName
          })
          .then((res) => {
            console.log(res);
            if(res.code == 'ok'){
                // this.$toast('已发送')
				this.textDesc = '';
				
				this.getmessagecon(this.targetUserId);
				
            }
            // this.$set(this.answerRecommend, index, res.translation);
            // e = res.translation;
            // console.log(e);
          });
       

       
    },

    //标记消息为已读

    readMessage(){
		console.log('messagelist',this.chatingList)

        let list=[]
        this.chatingList.forEach(p => {
            if(p.isRead === 0 && p.fromUserId != this.userId ){
                list.push(p.messageId)
            }
        })
		
		 console.log(list)
    let arrs = list.join(",");
    console.log(arrs);
    var arr = arrs.split(",");
    console.log(arr);
		if(list.length>0){
			api
        .messasread(
			{messageIds:arr}
		)
        .then(res => {
            if(res.code == 'ok') {
               
            }
        })
		}
        

    },
    //获取客户信息
    getUserMessage(){
        api
        .converlist({
            userId : this.userId
        })
        .then(res => {
            if(res.code == 'ok') {
            //    console.log('客户消息',res.conversations)
               this.userList = res.conversations;
               console.log(this.userList);
            }
			
			
        })
        

    },
	//websock链接
    connectWebsocket() {
      const wsuri = "wss://m.shopsbu.com/websocket/server-endpoint/"+this.userId;
      console.log(wsuri);
      this.websock = new WebSocket(wsuri);
      console.log(this.websock);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
      console.log(this.$t('other.a371'));
      // this.$message.success("websock链接成功");
    },
    websocketonerror() {
      //连接建立失败重连
      // this.connectWebsocket();
    //   this.$message.warning("websock链接失败,请刷新一下页面");
    },
    websocketonmessage(e) {
      //数据接收
     
      const redata =JSON.parse(e.data);
      console.log(redata);
      if(redata.type == 'erp-chat-message'){
        this.getUserMessage();
      }
      
      
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    },
    websocketclose(e) {
      //关闭
      console.log("断开连接", e);

    },
   

}
}

</script>
<style  scoped>
	.customerWrapper{
		
    }
    
	.customerWrapper .customerBox{
		display: flex;
		justify-content: space-between;
		height: calc(100vh - 110px);
		
		
	}
	
	.customerWrapper .user_num{
		padding: 10px;
		border-bottom: 1px #EEEEEE solid;
	}
	
	.customerWrapper .customer_left{
		width: 250px;
		overflow: hidden;
		
		border-right:1px solid #eeee ;
	}
	
	.customer_right{
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}
	
	.customerWrapper .shop_message{
		 border-bottom: 1px solid #eeee ;
		 cursor: pointer;
		display: flex;
		justify-content: flex-start;
		position: relative;
		box-sizing: border-box;
		padding: 5px 0;
	}
	.mess_body{
		position: relative;
	}
	.mess_con{
		position: absolute;
		top: 5px;
		right: 7px;
	}
  .mess_cons{
    position: absolute;
    top: 0px;
    left: 30px;
  }
	
	.customerWrapper .active{
		background-color: #eeee;
	}
	.customerWrapper .user_name{
		display: inline-block;
		width: 140px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		
	}
	
	.customerWrapper .customer_chat_recode{
		width: 100%;
		height: 350px;
		border-bottom: 1px solid #EEEEEE;
	}

	.customerWrapper .active::after{
	   content:" ";
	   background-color:#409eff;
	   width: 4px;
	   height: 60px;
		 position: absolute;
		top: 0;
		right:0px;
		z-index: 66px;
	}
	
	.customer_header{
		width: 100%;
		height: 40px;
		line-height: 40px;
		padding: 0 0 0 15px;
		border-bottom: 1px solid #E0E0E0;
		
		margin-bottom: 10px;
	}
	
	.customerWrapper .pic_box{
		width: 40px;
		height: 40px;
		border-radius: 50%;
		overflow: hidden;
	}
	
	.textBox_wrapper{
		width: 100%;
		flex: 1;
		
	}
	
    textarea {
		border:none;
		outline: none !important; 
		padding: 5px 10px;
		font-size: 20px;
	}
	.sendBtn{
		position:absolute;
		bottom: 10px;
		right: 20px;
	}
	
	.customerWrapper .textBox{
		width: 100%;
		height: 90%;
	
		
	}
	 .chat_recode_items{
			display: flex;
			align-items: center;
			margin:10px 10px;
			font-size: 14px;
	}
	
	.reverse_desc_row{
		 max-width: 300px;
		word-wrap: break-word;
		background-color: #409eff;
		padding: 8px 20px;
		margin:0 10px 5px 0px;
		color: #fff;
		border-radius: 20px 10px 0px 20px !important;
	}
	
	.reverse_row{
		flex-direction: row-reverse;
	}
	.customer_chat_recode{
			height: 70%;
			width: 100%;
			border-bottom: 1px solid #eeee;
			overflow-y:scroll;
	}
	
	.reverse_desc_row_pic{
		max-width: 300px;
		word-wrap: break-word;
		padding: 8px 20px;
		margin:0 0 5px 10px;
		color: #fff;
		border-radius: 20px 10px 0px 20px !important;
	}
	
	 .icon_tubiao{
		font-size: 20px;
		margin-right: 15px;
		cursor: pointer;
	}
	
	.middle_content{
		width: 100%;
		padding: 5px 10px;
		border-bottom: 1px solid #eeee;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
	
	.chat_desc{
		max-width: 300px;
		word-wrap: break-word;
		background-color: #C0C4CC;
		padding: 7px 20px;
		margin:0 0 5px 10px;
		
		border-radius: 10px 20px 20px 0;
		color: #000;
	}
	
	 .isRead{
			font-size: 12px;
			margin-right: 10px;
		}

	
	
	.customerWrapper .head_img_box{
		width: 50px;
		height: 50px;
		border-radius: 50%;
		overflow: hidden;
	}
	img{
		width: 100%;
	}
	
.el-upload-list__item  {
  display: none !important;
}



</style>